export default function Footer(): JSX.Element {
  return (
    <div className="w-full overflow-auto border-t-2  border-t-gray p-2 text-center">
      <p className="text-red"> © 2023 JUN WEI HUANG</p>
    </div>
  )
}
